<template>
  <div class="container table-responsive">

    <!-- POS Receipt Preview Modal Overlay -->
    <div v-if="showReceiptPreview" class="receipt-preview-overlay d-flex align-items-center justify-content-center">
      <div class="card shadow-lg border-0" style="width: 360px; max-width: 95vw;">
        <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center py-2">
          <h6 class="mb-0 font-weight-bold">Receipt Preview</h6>
          <button type="button" class="close text-white" @click="closeReceiptPreview">&times;</button>
        </div>
        
        <div class="card-body p-3 bg-secondary">
          <!-- Printable POS Receipt Container (80mm format) -->
          <div id="pos-receipt">
            <div style="width: 72mm; max-width: 100%; margin: 0 auto; padding: 12px; font-family: 'Courier New', Courier, monospace; font-size: 12px; color: #000; line-height: 1.3; box-sizing: border-box; background: #fff;">
              <!-- Line 1: 'Receipt' as title (centrally aligned) -->
              <div style="text-align: center; font-weight: bold; font-size: 16px; text-transform: uppercase; margin-bottom: 4px;">Receipt</div>
              
              <!-- Line 2: order['invoiceDate'] -->
              <div style="text-align: center; font-size: 11px; margin-bottom: 4px; color: #333;">{{ formattedInvoiceDate }}</div>
              
              <!-- Line 3: Org Name (say Ketco) -->
              <div style="text-align: center; font-weight: bold; font-size: 14px; margin-bottom: 8px;">{{ orgName || 'Ketco' }}</div>

              <!-- List of items in order: item1name + Item2Name, Price, Qty, Price -->
              <div style="border-top: 1px dashed #000; border-bottom: 1px dashed #000; padding: 6px 0; margin: 8px 0; font-size: 12px;">
                <div v-for="(item, idx) in submittedOrderItems" :key="idx" style="margin-bottom: 8px;">
                  <div style="font-weight: bold; word-break: break-word;">{{ getItemDisplayName(item) }}</div>
                  <table style="width: 100%; border: none; font-family: inherit; font-size: 11px; margin-top: 2px;">
                    <tr>
                      <td style="text-align: left; color: #555; padding: 0; border: none;">
                        {{ Number((getItemSubtotal(item) / item.qty)).toFixed(2) }} &times; {{ item.qty || item.quantity || 1 }}
                      </td>
                      <td style="text-align: right; font-weight: bold; color: #000; padding: 0; border: none;">
                        {{ getItemSubtotal(item) }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

              <!-- Finally show total for the order -->
              <table style="width: 100%; border: none; font-family: inherit; font-size: 14px; font-weight: bold; margin: 8px 0;">
                <tr>
                  <td style="text-align: left; padding: 0; border: none;">TOTAL:</td>
                  <td style="text-align: right; padding: 0; border: none;">INR {{ submittedOrderTotal }}</td>
                </tr>
              </table>

              <!-- Note (if present) -->
              <div v-if="submittedOrderNote" style="border-top: 1px dashed #000; padding-top: 6px; margin-top: 6px; font-size: 11px; text-align: left; word-break: break-word;">
                <strong>Note:</strong> {{ submittedOrderNote }}
              </div>

              <!-- Footer: Thank you for your business. -->
              <div style="border-top: 1px dashed #000; padding-top: 8px; margin-top: 10px; text-align: center;">
                <div style="font-weight: bold; font-size: 12px; margin-bottom: 4px;">Thank you for your business.</div>
                <!-- Bottom: order['orderNbr'] -->
                <div style="font-size: 11px; font-weight: bold; color: #444;">{{ submittedOrderNbr }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Options: ESC/POS Print, Web Print and Cancel -->
        <div class="card-footer bg-white py-2">
          <div v-if="printInProgress" class="alert alert-info py-1 px-2 mb-2 text-center font-weight-bold" style="font-size: 13px;">
            <i class="fa fa-spinner fa-spin mr-1"></i> Receipt Print in progress. Please wait...
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <button type="button" class="btn btn-secondary btn-sm" @click="closeReceiptPreview" :disabled="printInProgress">
              Cancel
            </button>
            <button type="button" class="btn btn-dark btn-sm font-weight-bold" @click="printESCPOSDirectOrder('auto')" :disabled="printInProgress" title="Send raw ESC/POS commands to Thermal Printer">
              <i class="fa" :class="printInProgress ? 'fa-spinner fa-spin' : 'fa-print'"></i> Print
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="receiptFlag">	
      <div>
        <button type="button" class="btn btn-warning float-left" v-on:click.prevent="receiptFlag=false">
          <i class="fa fa-angle-left"></i> Back to Cart
        </button>
        <button type="button" :disabled="cartValue==0" class="btn btn-success float-right" @click="printReceipt">
          Print
        </button>
      </div>
      <br><br>
	
      <div id="receipt">
        <span v-html="receiptHTML"></span>
      </div>
    </div>
    <div v-else>	
      <div>
        <button type="button" class="btn btn-warning float-left" @click="backToShoppingCart">
          <i class="fa fa-angle-left"></i> Back to Shopping
        </button>
        <!-- <button type="button" :disabled="cartValue==0" class="btn btn-success float-right" @click="getReceipt">
          Receipt <i class="fa fa-angle-right"></i>
        </button> -->
      </div>
      <br><br>
      <table id="cart" class="table table-hover table-sm">
        <thead>
          <tr>
            <th style="width:40%">Product</th>
            <th style="width:10%">Price</th>
            <th style="width:10%">Discount</th>
            <th style="width:8%">Quantity</th>
            <th style="width:22%;padding-right: 25px;" class="text-right">Subtotal</th>
            <th style="width:10%"></th>
          </tr>
        </thead>

        <transition-group name="list-shopping-cart" tag="tbody">
          <app-cart-item
            v-for="cartItem in cartItemList"
            :cartItem="cartItem"
            :key="cartItem.name"
          ></app-cart-item>
        </transition-group>

        <tfoot>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td class="text-right"><strong>Base Total</strong></td>
            <td style="padding-right: 25px;" class="text-right"><strong>{{ cartValue }}</strong></td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td class="text-right">Tax</td>
            <td style="padding-right: 25px;" class="text-right">{{ taxValue }}</td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td class="text-right"><strong>Total</strong></td>
            <td style="padding-right: 25px;" class="text-right"><strong>{{ totalValue.toFixed(2) }}</strong></td>
            <td></td>
          </tr>
        </tfoot>
      </table>
      <br>

      <div class="card">
        <div class="card-body">

          <div class="form-group row">
            <label class="col-sm-3 col-form-label font-weight-bold text-right">Sale Date</label>
            <!-- <div class="col-sm-2 text-left">  :bootstrap-styling="true"  -->
              <datepicker :disabled="cartValue==0" v-model="payment.invoiceDate" name="currentDate" 
                          
                          :disabled-dates="disabledDates"></datepicker>
            <!-- </div> -->

            <label class="col-sm-3 col-form-label font-weight-bold text-right">Sale Invoice?</label>
            <div class="form-check form-check-inline">
              <input v-model="payment.invoiceIssued" class="form-check-input" type="radio" id="inlineRadio3" value="Yes" />
              <label class="form-check-label" for="inlineRadio3">Yes</label>
            </div>
            <div class="form-check form-check-inline">
              <input v-model="payment.invoiceIssued" class="form-check-input" type="radio" id="inlineRadio4" value="No" />
              <label class="form-check-label" for="inlineRadio4">No</label>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-3 col-form-label font-weight-bold text-right">Invoice Nbr</label>
            <input type="text" :disabled="payment.invoiceIssued=='No'" class="col-sm-2 form-control" v-model="payment.invoiceNbr">
            
            <label class="col-sm-3 col-form-label font-weight-bold text-right">GST Nbr</label>
            <input type="text" :disabled="payment.invoiceIssued=='No'" class="col-sm-2 form-control" v-model="payment.GSTN">
          </div>

          <div class="form-group row">
            <label class="col-sm-3 col-form-label font-weight-bold text-right">Cash Paid</label>
            <input type="number" ref="paidAmtCash" :disabled="cartValue==0" class="col-sm-2 form-control" v-model.number="payment.paidCash"
                @focus="$event.target.select()"  v-on:keyup="onAmtChange()">

            <label class="col-sm-3 col-form-label font-weight-bold text-right">Bank Paid</label>
            <input type="number" :disabled="cartValue==0" class="col-sm-2 form-control" v-model.number="payment.paidBank"
                @focus="$event.target.select()"  v-on:keyup="onAmtChange()">
          </div>

          <!-- <div class="form-group row">
            <label class="col-sm-3 col-form-label font-weight-bold text-right">Return</label>
            <label class="col-sm-2 col-form-label text-left">{{ payment.returned }}</label>

            <label class="col-sm-3 col-form-label font-weight-bold text-right">Outstanding</label>
            <label class="col-sm-2 col-form-label text-left">{{ payment.outstanding }}</label>
          </div> -->

          <div v-if="serviceFlag" class="form-group row">
            <label class="col-sm-3 col-form-label font-weight-bold text-right">Ticket Nbr</label>
            <input type="text" class="col-sm-2 form-control" v-model="payment.serviceTicket">

            <!-- <label class="col-sm-3 col-form-label font-weight-bold text-right">Repair Cost</label>
            <input type="number" class="col-sm-2 form-control" v-model.number="payment.serviceCost"
                @focus="$event.target.select()"  v-on:keyup="onServiceCostChange()"> -->
          </div>

          <div class="form-group row">
            <label class="col-sm-3 col-form-label font-weight-bold text-right">Note</label>
            <textarea class="col-sm-7 form-control" v-model="payment.note"></textarea>
          </div>

          <div class="row justify-content-sm-center">
              <button :disabled="cartValue==0 || isLoggedIn==false" class="btn btn-success" @click="submitOrder">
                Submit Order
              </button>
          </div>
        </div>  
      </div>
      <br>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CartItem from './cart/CartItem.vue'
import Datepicker from 'vuejs-datepicker'
import axios from "axios"
import { printESCPOSDirect } from '../utils/escpos'
// import { firebase } from '@firebase/app'

export default {
  computed: {
    ...mapGetters([
      'cartItemList',
      'isLoggedIn',
      'products',
      'currentUser',
      'cartValue',
      'taxValue',
      'totalValue',
      'orgId',
      'location',
      'payment',
      'serviceFlag',
      'orgName',
    ]),

    formattedInvoiceDate() {
      const now = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      const day = pad(now.getDate());
      const month = pad(now.getMonth() + 1);
      const year = String(now.getFullYear()).slice(-2);
      const hours = pad(now.getHours());
      const minutes = pad(now.getMinutes());
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
    submittedOrderItems() {
      if (this.submittedOrder && this.submittedOrder.items) {
        return this.submittedOrder.items;
      }
      return [];
    },
    submittedOrderTotal() {
      if (this.submittedOrder && this.submittedOrder.total !== undefined) {
        return Number(this.submittedOrder.total).toFixed(2);
      }
      return '0.00';
    },
    submittedOrderNbr() {
      if (this.submittedOrder){
          return this.submittedOrder.orderNbr
      }
      return 'N/A';
    },
    submittedOrderNote() {
      if (this.submittedOrder) {
        return String(this.submittedOrder.note || this.submittedOrder.paymentNote || this.submittedOrder.notes || '').trim();
      }
      if (this.payment && this.payment.note) {
        return String(this.payment.note).trim();
      }
      return '';
    },
  },
  components: {
    appCartItem: CartItem,
    Datepicker,
  },

  data () {
    return {
      showReceiptPreview: false,
      submittedOrder: null,
      printInProgress: false,
      disabledDates: {
          to: new Date(new Date().getTime() - (120 * 24 * 60 * 60 * 1000)),
          from: new Date(),
      },
      receiptFlag: false,
      receiptHTML: null,
      stateList: ["Andhra Pradesh","Andaman and Nicobar Islands","Arunachal Pradesh","Assam","Bihar",
                  "Chandigarh","Chhattisgarh","Dadar and Nagar Haveli","Daman and Diu","Delhi","Lakshadweep",
                  "Puducherry","Goa","Gujarat","Haryana","Himachal Pradesh","Jammu and Kashmir","Jharkhand",
                  "Karnataka","Kerala","Madhya Pradesh","Maharashtra","Manipur","Meghalaya","Mizoram",
                  "Nagaland","Odisha","Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana","Tripura",
                  "Uttar Pradesh","Uttarakhand","West Bengal"],
    }
  },

  mounted(){
    this.focusInput()
  },

  methods: {
    ...mapActions([
      'saveShoppingCart',
      'addMessage',
      'saveToTransaction',
      'clearCart',
      'setCart',
      'setPayment',
      'clearPayment',
      'setItemLevel'
    ]),

    focusInput() {
      this.$refs.paidAmtCash.focus();
    },

    checkValidCart(itemList, prodList) {
      let isValid = true
      let message = ''

      itemList.map((item) => {
        for (let prodIdx = 0; prodIdx < prodList.length; prodIdx++) {
          if (prodList[prodIdx].id == item.id) {
            if (prodList[prodIdx].quantity < item.quantity) {
              message = `Only ${prodList[prodIdx].quantity} ${item.title} available in stock`
              isValid = false
              return
            }
            break
          }
        }
      })
      return {
        isValid,
        message,
      }
    },

    backToShoppingCart() {
      var itemLevel = 1
      this.setItemLevel({itemLevel})
      this.$router.push('/' + this.orgId + '/' + this.location)
    },

    // Discount/Surcharge = Total - Paid + Returned
    onAmtChange() {
      this.payment.paidTotal = this.payment.paidCash + this.payment.paidBank
      var delta = Number(this.cartValue) + this.payment.surcharge - this.payment.discount - Number(this.payment.paidTotal)
      if (delta > 0){
        this.payment.outstanding = delta.toFixed(2)
        this.payment.returned = 0
      }
      else{
        this.payment.outstanding = 0
        this.payment.returned = (0 - delta).toFixed(2)
      }
    },

/*     onAmtChange() {
      this.payment.paidTotal = this.payment.paidCash + this.payment.paidBank
      var delta = Number(this.cartValue) - Number(this.payment.paidTotal) + Number(this.payment.returned)
      if (delta > 0){
        this.payment.discount = delta.toFixed(2)
        this.payment.surcharge = 0
      }
      else{
        this.payment.discount = 0
        this.payment.surcharge = (0 - delta).toFixed(2)
      }
    }, */

    // onServiceCostChange() {
    //   // Set amount for current cart item
    //   if (this.cartItemList.length == 1){
    //     this.cartItemList[0]['priceAfterTax'] = this.payment.serviceCost 
    //     this.setCart(this.cartItemList)
    //   }
    //},

    getReceipt(){
      let order = this.createOrder()
      if (order)
        this.serverCall('getReceipt', order)
    },

    submitOrder() {
      var order = this.createOrder()
      if (order)
        this.serverCall('saveOrder', order)
      //console.log(order)
    },

    createOrder() {
      if (!this.cartItemList || this.cartItemList.length == 0) {
          this.addMessage({messageClass: 'warning', message: 'Your cart is empty!',})
          return (null)
        }

      let cartItemList = this.cartItemList 
      let cartValue = this.cartValue
      let taxValue = this.taxValue
      let totalValue = this.totalValue
      let location = this.location
      let payment = this.payment

      let paidCash = Number(payment.paidCash || 0)
      let paidBank = Number(payment.paidBank || 0)
      let paidTotal = paidCash + paidBank
      let total = Number(totalValue || 0)

      if (Math.abs(total - paidTotal) > 5.00) {
        this.addMessage({
          messageClass: 'danger', 
          message: 'Difference between Total and Paid amount (Cash + Bank) is more than 5.00.'
        })
        return (null)
      }

	    this.addMessage({messageClass: "warning", message: "Please wait, creating order..."})

      var partner = 
      {
        nbr: '',
        type: 'Customer',
        name: location,
        inState: 'Yes',
        phone: '',
        email: '',
        GSTN: payment.GSTN || '',
        state: '',
        address1: '',
        address2: '',
        address3: '',
        transporter: '',
        transportDest: '',
        note: '',
        vgtSelected: false
      }
	
      // Create Order Object
      let order = {
        'nbr': null,
        'type': 'Sale',
        'location': location,
        'items': [],
        'status': 0,
        'invoiceIssued': payment.invoiceIssued,
        'GSTN': payment.GSTN,
        'altNbr': payment.invoiceNbr,
        'invNbr': null,
        'orderNbr': null,
        'baseTotal': Number(cartValue),
        'tax': Number(taxValue),
        'inState': 'Yes', 
        'total': Number(totalValue),
        'total1': 0,
        'total2': 0,
        'createDate': null,
        'paid': 'Yes',
        'curPayDate': payment.invoiceDate,
        'curPayType': '',
        'curPayAmt': Number(payment.paidTotal),
        'payInstructions': '',
        'payments': [],
        'paidTotal': Number(payment.paidTotal),
        'paidCash': Number(payment.paidCash),
        'paidBank': Number(payment.paidBank),
        'paidSoFar': Number(payment.paidTotal),
        'discount': Number(payment.discount),
        'surcharge': Number(payment.surcharge),
        'outstanding': Number(payment.outstanding),
        'serviceTicket': payment.serviceTicket,
        'delivered': 'Yes',
        'deliveryDate': payment.invoiceDate,
        'invoiceDate': payment.invoiceDate,
        'note': payment.note,
        'deliveryReady': 'No',
        'cancelled': 'No',
        'cancelledDate': null,
        'updateDate': null,
        'partner': partner,
      }

      var currentDate = new Date()
      currentDate.setHours(12)
      currentDate.setMinutes(0)
      currentDate.setSeconds(0)
      currentDate.setMilliseconds(0)
      order.createDate = currentDate
      order.updateDate = currentDate

      // Add Items
      var items = []
      for (let i = 0; i < cartItemList.length; i++) {
        let item = {}
        item.name = cartItemList[i].name
        item.item1Name = cartItemList[i].item1Name
        item.price = cartItemList[i].price
        item.cost = 0
        item.qty = cartItemList[i].quantity
        item.tax = (cartItemList[i].price - cartItemList[i].discount) * cartItemList[i].quantity * cartItemList[i].taxrate/100
        item.tax = Number(item.tax.toFixed(2))
        item.surcharge = 0
        item.discount = cartItemList[i].discount
        item.minSalesTax = 0
        item.baseTotal = (cartItemList[i].price - cartItemList[i].discount) * cartItemList[i].quantity
        item.baseTotal = Number(item.baseTotal.toFixed(2))
        item.total = item.baseTotal + item.tax
        item.CGST = {'amt': 0, 'apply': 'Yes'}
        item.SGST = {'amt': 0, 'apply': 'Yes'}
        item.IGST = {'amt': 0, 'apply': 'No'}
        items.push(Object.assign({}, item))
      }
      order['items'] = items

      return (order)
    },

    serverCall (name, params) {
      var self = this

      if (this.isLoggedIn){
          this.currentUser.getIdToken().then(function(idToken) { 
            switch (name) {
              case 'saveOrder':
                self.saveOrder(idToken, params)
                break

              case 'getReceipt':
                self.getReceiptFromServer(idToken, params)
                break

              default:
                console.log('Unknown function: ' + name)
            }
          })
        } else {
          this.addMessage({messageClass: "warning", message: "User logged out. Please login."})
        }

    },

    saveOrder(idToken, order) {
      var self = this
      let message = ""

      if (this.payment.invoiceNbr.trim() != ''){
        order.total1 = order.total
        order.total2 = 0
      }
      else {
        order.total1 = 0
        order.total2 = order.total        
      }

      axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_ROOT_API,
        url: '/SaveOrder/',
        data: order,
        headers: {
          'Authorization': 'Bearer ' + idToken,
          'OrgId': self.orgId,
          'Content-Type': 'application/json',
        },
      })
      .then(function (response) {
        if (response.data.err != '') {
          message = response.data.err
          self.addMessage({messageClass: "danger", message: message})
        } else {
          order.invNbr = response.data.invNbr
          order.orderNbr = response.data.orderShortNbr
          message = "Order Submitted."  

          self.submittedOrder = Object.assign({}, order)
          self.showReceiptPreview = true
          self.addMessage({messageClass: "success", message: message})
        }
      })
      .catch(function (error) {
        self.addMessage({messageClass: "danger", message: String(error)})
      })
    },

    getItemDisplayName(item) {
      if (!item) return '';
      let item1 = item.item1Name || '';
      let item2 = item.name || item.title || '';
      if (item1 && item2 && item1 !== item2) {
        return item1 + ' ' + item2;
      }
      return item2 || item1 || 'Item';
    },

    getItemSubtotal(item) {
      if (!item) return '0.00';
      let price = Number(item.price || 0);
      let qty = Number(item.qty || item.quantity || 1);
      if (item.total !== undefined) {
        return Number(item.total).toFixed(2);
      }
      return (price * qty).toFixed(2);
    },

    closeReceiptPreview() {
      this.showReceiptPreview = false;
      this.submittedOrder = null;
      this.clearCart();
      this.clearPayment();
      this.backToShoppingCart();
    },

    async printPOSReceipt() {
      if (this.$htmlToPaper) {
        await this.$htmlToPaper('pos-receipt');
      } else {
        window.print();
      }
    },

    async printESCPOSDirectOrder(type = 'auto') {
      if (this.printInProgress) return;

      const order = this.submittedOrder || {
        orderItems: this.cartItemList,
        total: this.totalValue,
        invoiceDate: new Date(),
        orderNbrShort: 'DRAFT'
      };

      this.printInProgress = true;
      this.addMessage({ messageClass: "info", message: "Sending ESC/POS receipt directly to USB printer..." });

      try {
        const options = { orgName: this.orgName || 'Ketco' };
        if (type && type !== 'auto') {
          options.connectionType = type;
        }
        await printESCPOSDirect(order, options);
        this.addMessage({ messageClass: "success", message: "ESC/POS receipt printed successfully." });
      } catch (err) {
        console.warn('Printer error:', err);
        this.addMessage({ messageClass: "danger", message: err.message || "Failed to print ESC/POS receipt." });
      } finally {
        this.printInProgress = false;
      }
    },

    // Get Receipt
    async getReceiptFromServer (idToken, order) {
      var self = this

      // Set loading message
      // self.loading = true
      // self.loadingMsg = 'Getting Receipt...'
      this.addMessage({messageClass: "warning", message: "Please wait, preparing sale receipt..."})

      var formData = new FormData()
      formData.append('order', JSON.stringify(order))
      formData.append('receiptType', 'OrderReceipt')

      await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_ROOT_API,
        url: '/GetReceipt/',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + idToken,
          'OrgId': self.orgId,
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(async function (response) {
          if (response.data.err != '') {
            //self.$alert(response.data.err, '', 'error', { confirmButtonColor: '#161c2d' })
            self.addMessage({messageClass: "danger", message: response.data.err})
          } else {
            // var win = window.open("", "Receipt")
            // win.document.body.innerHTML = response.data.receiptHtml
            self.receiptHTML = response.data.receiptHtml
            self.receiptFlag = true
          }
          // Reset loading message
          // self.loading = false
          // self.loadingMsg = null
        })
        .catch(function (error) {
          //self.$alert(String(error), '', 'error', { confirmButtonColor: '#161c2d' })
          self.addMessage({messageClass: "danger", message: String(error)})
          // Reset loading message
          // self.loading = false
          // self.loadingMsg = null
        })
    },

    async printReceipt () {
      await this.$htmlToPaper('receipt')
    },

  },
}
</script>

<style lang="scss" scoped>
.receipt-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.65);
  z-index: 2000;
}

.pos-receipt-container {
  width: 280px;
  font-family: 'Courier New', Courier, monospace;
  color: #000;
  box-shadow: 0 0 5px rgba(0,0,0,0.1);
  line-height: 1.3;
}

@media print {
  @page {
    size: 80mm auto;
    margin: 0;
  }
  body * {
    visibility: hidden !important;
  }
  #pos-receipt, #pos-receipt * {
    visibility: visible !important;
  }
  #pos-receipt {
    position: absolute;
    left: 0;
    top: 0;
    width: 80mm;
    margin: 0;
    padding: 10px !important;
    box-shadow: none !important;
  }
}

.list-shopping-cart-leave-active {
  transition: all 0.4s;
}

.list-shopping-cart-leave-to {
  opacity: 0;
  transform: translateX(50px);
}

.table-sm {
  font-size: 0.875rem;
  ::v-deep h4 {
    font-size: 1.25rem;
  }
}
</style>
